import ManageThreadsDialog from "./ManageThreadsDialog";

export default ManageThreadsDialog;
